import * as React from 'react';
import styled, { css } from 'styled-components';
import { Placement } from '../types';




const placementStyles = {
    'top-left':         css`top: 0; left: 0; flex-direction:column;`,
    'top-center':       css`top: 0; left: 50%; transform: translateX(-50%); flex-direction:column;`,
    'top-right':        css`top: 0; right: 0; flex-direction:column;`,
    'bottom-left':      css`bottom: 0; left: 0; flex-direction:column-reverse;`,
    'bottom-center':    css`bottom: 0; left: 50%; transform: translateX(-50%); flex-direction:column-reverse;`,
    'bottom-right':     css`bottom: 0; right: 0; flex-direction:column-reverse;`,
};

const StyledToastContainer = styled.div<{placement:Placement}>`
    max-height:100%;
    position:fixed;
    z-index:2000;
    padding:${({ theme }) => theme.spacing(1)};
    display:flex;
    /* get the mapped css for the transition state */
    ${({ placement }) => placementStyles[placement]}

`;

type ToastContainerProps = {
    placement: Placement
}

const ToastContainer: React.FC<ToastContainerProps> = props => {
    const {placement, children} = props

    return (
        <StyledToastContainer {...{placement}}>
            {children}
        </StyledToastContainer>
    )
}


export default ToastContainer;
export { ToastContainer, ToastContainerProps };